module.exports = __webpack_public_path__ + "static/media/Паспорт_светильник GALAD_Волна_LED-150-ШБ.49ffbe91.pdf";